export function MapHeader() {
  return (
    <header
      className="fixed top-0 left-0 right-0 z-30 pointer-events-none"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
    >
      <div className="mx-4 mt-3 pointer-events-auto">
        <div
          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-2xl"
          style={{
            background: "rgba(255,255,255,0.88)",
            backdropFilter: "blur(16px) saturate(1.4)",
            WebkitBackdropFilter: "blur(16px) saturate(1.4)",
            boxShadow: "0 2px 12px rgba(26,25,23,0.08)",
          }}
        >
          {/* KRA logo text */}
          <span
            className="text-base font-semibold tracking-wide"
            style={{ color: "#B76E6E" }}
          >
            KRA
          </span>
          <span className="w-px h-4 bg-ink-3/40" />
          <span className="text-xs font-medium text-ink-1">
            Asakusa Photo Spots
          </span>
        </div>
      </div>
    </header>
  );
}
